import "../../styles/all.css";
import "./company.css";
import { useTranslation } from "react-i18next";

function Company() {
  const { t } = useTranslation();

  return (
    <>
      <div className="back" data-aos="fade-left">
        <div className="continerr">
          <h2>{t("companytitle")}</h2> 
          <h3>{t("companysubtitle")}</h3>
        </div>
      </div>
    </>
  );
}

export default Company;